<script setup lang="ts">

</script>

<template>
  <div class="w-full">
    <div class="mx-auto flex flex-col items-center gap-y-6">
      <img
        class="size-[88px] object-cover"
        src="@/assets/images/emojis/emoji-confetti.png"
      >
      <div class="flex flex-col gap-y-2 text-base font-medium text-white/60">
        <div class="text-center text-light-white text-[18px] leading-7 font-bold">
          Phase 2: Token Generation Event (Timing TBD)
        </div>
        <p>
          Once market conditions are right, we’ll open the TGE so you can <span class="text-white/[.87] font-semibold">claim your $DROPEE share</span>.
          <br>
          <br>
          Don’t stop on May 31—players who <span class="text-white/[.87] font-semibold">keep playing</span> and improve
          their scores across these same pillars will gain an
          <span class="text-white/[.87] font-semibold">extra edge</span> when we finalize allocations.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>